<template>
  <span><gj-button type="text" @click="clickOrder">{{orderId}}</gj-button></span>
</template>

<script>
  import OrderDetail from '../../views/modules/sale/saleOrder/modal/sale-order-detail';

    export default {
        name: "app-order-detail",
        props: {
            modalMountTo: {
                default: null
            },
          marketId: {
            type: Number | String,
            require: true
          },
          orderId: {
            type: String,
            require: true
          },
        },
        methods: {
          clickOrder() {
            this.$gjCreate(OrderDetail, {
                mountTo: this.modalMountTo,
                props: {
                  marketId: this.marketId,
                  orderId: this.orderId
                }
            })
          }
        }
    }
</script>

<style scoped>

</style>
